import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import axios from 'axios';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const generateReturnPDF = async (returnId) => {
  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem("company_tax_type") || "VAT";

  const formData = new FormData();
  formData.set('id', returnId);
  const apiUrl = `${config.API_URL}/return/returnView`;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Helper function to format currency
  const formatCurrency = (amount) => {
    return `£${parseFloat(amount || 0).toFixed(2)}`;
  };

  // Helper function to format product name
  const formatProductName = (productCode, productName, size) => {
    const formattedName = productName.replace(/(\d+)/, ' $1'); // Add space before numbers
    return `${productCode} - ${formattedName} - ${size}`;
  };

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    const data = response.data;
    console.log(data);

    if (!data.success || !data.data) {
      console.error("No return details found in the response.");
      return;
    }

    const shopDetails = data.data.shop_details;
    const commonData = data.data.commonData;
    const itemData = data.data.itemData;

    // Calculate totals
    const totalAmount = parseFloat(commonData.grand_total) || 0;
    const totalTax = parseFloat(commonData.total_tax) || 0;
    const totalWithoutTax = totalAmount - totalTax;

    // Calculate quantities
   const box_qty = itemData
  .filter(item => item.return_type === 'box' && parseFloat(item.quantity) > 0)
  .reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);

const piece_qty = itemData
  .filter(item => item.return_type === 'piece' && parseFloat(item.quantity) > 0)
  .reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);


    const addRibbonTitle = (doc, title, fontSize, pageWidth, margin, topMargin) => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(fontSize);
      doc.setTextColor(0, 0, 0);
      
      const titleWidth = doc.getTextWidth(title);
      const titleX = pageWidth - titleWidth - margin;
      const titleY = topMargin + fontSize;
      
      doc.text(title, titleX, titleY);
    };

    const doc = new jsPDF('portrait');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    let y = margin;

    // Column widths for header sections
     const firstColumnWidth = pageWidth * 0.25;
    const H2firstColumnWidth = pageWidth * 0.40;
    const H2secondColumnWidth = pageWidth * 0.25;
    const H2thirdColumnWidth = pageWidth * 0.25;

    // Add logo
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 15;
    doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight);
    y += logoHeight + 5;

    // Add title
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    const title = " ";
    const fontSize = 14;
    const topMargin = 5;
    addRibbonTitle(doc, title, fontSize, pageWidth, margin, topMargin);
    y += 15;

    // Shop details section
    const headerSections2 = [
      [],
      [
        { text: `${shopDetails.shop_name}`, size: 12, bold: true },
        { text: `${shopDetails.address.split(',')[0]}`, size: 9, bold: false },
        { text: `${shopDetails.address.split(',')[1] || ''}`, size: 9, bold: false },
        { text: `Company No: ${shopDetails.company_reg_no}`, size: 9, bold: false },
        { text: `Phone No: ${shopDetails.phone} | Email: ${shopDetails.email}`, size: 9, bold: false },
        { text: `Website: ${shopDetails.website}`, size: 9, bold: false },
      ],
    ];
     y = 7;
    // Render shop details
    const renderSections = (sections, marginTop = 7) => {
      let yPosition = y + marginTop;

      sections.forEach((section, index) => {
    // Calculate starting X position for the columns (for layout)
    const colStartX = margin + (index % 3) * firstColumnWidth;

    section.forEach((item, i) => {
      doc.setFontSize(item.size);
      doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
      doc.text(item.text, colStartX, yPosition + i * 4); // Adjust Y based on current position
    });

    // Increase the Y position after rendering each section
    if (index % 4 === 3) {
      yPosition += 12; // Adjust spacing between sections as needed
    }
  });

      yPosition += 25;
      y = yPosition;
    };

    renderSections(headerSections2);

    // Customer and return details
    const headerSections3 = [
      [
        { text: `Customer Details`, size: 10, bold: true },
        { text: `${commonData.company}`, size: 9, bold: true },
        { text: `${commonData.line1}`, size: 9, bold: false },
        { text: `${commonData.postal_code}`, size: 9, bold: false },
        { text: `Phone No: ${commonData.phone}`, size: 9, bold: false },
        { text: `Email: ${commonData.email || 'N/A'}`, size: 9, bold: false },
      ],
      [
        { text: `Return Details`, size: 10, bold: true },
        { text: `Return No: ${commonData.reference_no}`, size: 9, bold: false },
        { text: `Return Date: ${formatDate(commonData.date)}`, size: 9, bold: false },
        { text: `A/C No: ${commonData.accound_no}`, size: 9, bold: false },
        { text: `Route No: ${commonData.route_number}`, size: 9, bold: false },
        { text: `Total Items: ${itemData.length}`, size: 9, bold: false },
      ],
      [
        { text: `Bank Details`, size: 10, bold: true },
        { text: `${shopDetails.shop_name}`, size: 9, bold: true },
        { text: `A/C No: ${shopDetails.bank_ac}`, size: 9, bold: false },
        { text: `Sort Code: ${shopDetails.sort_code}`, size: 9, bold: false },
        { text: ``, size: 9, bold: false },
        { text: ``, size: 9, bold: false },
      ],
    ];

    // Render customer details with proper borders
    const h2renderSections = (sections) => {
      const sectionHeight = 35;
      const rowStartY = y;

      sections.forEach((section, index) => {
        let colStartX;
        let colWidth;
        
        if (index % 3 === 0) {
          colStartX = margin;
          colWidth = H2firstColumnWidth;
        } else if (index % 3 === 1) {
          colStartX = margin + H2firstColumnWidth;
          colWidth = H2secondColumnWidth;
        } else {
          colStartX = margin + H2firstColumnWidth + H2secondColumnWidth;
          colWidth = H2thirdColumnWidth;
        }

        // Draw section border
        doc.setLineWidth(0.4);
        doc.setDrawColor(0, 0, 0);
        doc.rect(colStartX, rowStartY, colWidth, sectionHeight);

        // Render section content
        section.forEach((item, i) => {
          if (item.text) {
            doc.setFontSize(item.size);
            doc.setFont('helvetica', item.bold ? 'bold' : 'normal');
            doc.text(item.text, colStartX + 3, rowStartY + 8 + i * 5);
          }
        });
      });

      y += sectionHeight + 10;
    };

    h2renderSections(headerSections3);

    let totalzeroGoods = 0;
    let totalstd = 0;
    let totalVAT = 0;

    itemData.forEach(item => {
      const tax = parseFloat(item.tax) || 0;
      const subtotal = parseFloat(item.subtotal) || 0;
      if (tax === 0) {
        totalzeroGoods += subtotal- tax;
      } else {
        totalstd += subtotal - tax;
        totalVAT += tax;
      }
    });
    // Table for return items
    const tableColumns = [
      { title: 'Product', dataKey: 'product' },
      { title: 'Type', dataKey: 'return_type' },
      { title: 'Qty', dataKey: 'qty' },
      { title: 'Price', dataKey: 'unit_price' },
      { title: `${company_tax_type}`, dataKey: 'tax' },
      { title: 'Total', dataKey: 'subtotal' },
    ];

    // Calculate table widths
    const totalWidth = pageWidth - 2 * margin;
    const productWidth = totalWidth * 0.40;
    const returnTypeWidth = totalWidth * 0.12;
    const qtyWidth = totalWidth * 0.08;
    const unitPriceWidth = totalWidth * 0.13;
    const taxWidth = totalWidth * 0.13;
    const subtotalWidth = totalWidth * 0.14;

    // Construct table body with proper formatting
    const tableBody = itemData.map((item) => [
      formatProductName(item.product_code, item.product_name, item.size),
      item.return_type,
      parseInt(item.quantity),
      formatCurrency(item.unit_price),
      formatCurrency(item.tax),
      formatCurrency(item.subtotal),
    ]);

    // Add totals rows
    // tableBody.push([
    //   { content: 'Total Zero Goods:', colSpan: 5, styles: { halign: 'right', fontStyle: 'bold' } },
    //   { content: formatCurrency(totalWithoutTax), styles: { fontStyle: 'bold' } }
    // ]);
    tableBody.push([
      { content: `Total Zero Goods - £ ${totalzeroGoods.toFixed(2)}  | Total Std Goods - £ ${totalstd.toFixed(2)}`, colSpan: 4, styles: { halign: 'left',fontStyle: 'bold' } }, 
      { content: `${company_tax_type} Amount:`,  styles: { halign: 'right',fontSize :8,fontStyle: 'bold' } }, 
      {content : `£ ${totalVAT.toFixed(2)}` }

      ]);
    // tableBody.push([
    //   { content: `${company_tax_type} Amount:`, colSpan: 5, styles: { halign: 'right', fontStyle: 'bold' } },
    //   { content: formatCurrency(totalTax), styles: { fontStyle: 'bold' } }
    // ]);

    tableBody.push([
      { content:  `Box : ${box_qty} PCs : ${piece_qty}` , colSpan: 4, styles: { halign: 'left', fontStyle: 'bold' } },
      { content: 'Return Total:', styles: { halign: 'right', fontStyle: 'bold' } },
      { content: formatCurrency(totalAmount), styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } }
    ]);

    doc.autoTable({
      startY: y,
      head: [tableColumns.map(col => col.title)],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontSize: 9,
        fontStyle: 'bold',
        valign: 'middle',
        halign: 'center',
        lineWidth: 0.3,
        lineColor: [0, 0, 0]
      },
      bodyStyles: {
        fontSize: 9,
        valign: 'middle',
        lineWidth: 0.3,
        lineColor: [0, 0, 0]
      },
      alternateRowStyles: {
        fillColor: [250, 250, 250]
      },
      margin: { top: 0, left: margin, right: margin },
      columnStyles: {
        0: { cellWidth: productWidth, fontSize: 8, halign: 'left' },
        1: { cellWidth: returnTypeWidth, fontSize: 9, halign: 'center' },
        2: { cellWidth: qtyWidth, fontSize: 9, halign: 'center' },
        3: { cellWidth: unitPriceWidth, fontSize: 9, halign: 'right' },
        4: { cellWidth: taxWidth, fontSize: 9, halign: 'right' },
        5: { cellWidth: subtotalWidth, fontSize: 9, halign: 'right' },
      },
    });

    y = doc.autoTable.previous.finalY + 15;

    // Add footer terms with proper spacing
    const footerSections = [
      [
        { text: 'Return Terms:', size: 10, bold: true },
        { text: '1 - Return processed and refund amount calculated as per company policy', size: 9, bold: false },
        { text: '2 - Refund will be processed within 7-10 working days', size: 9, bold: false },
        { text: '3 - Items must be in original condition for return acceptance', size: 9, bold: false },
        { text: '4 - Return authorization required for all returns', size: 9, bold: false },
      ]
    ];

    // Check if there's enough space for footer
    const remainingSpace = pageHeight - y - margin;
    const requiredSpace = footerSections[0].length * 6 + 20;

    if (remainingSpace < requiredSpace) {
      doc.addPage();
      y = margin;
    }

    // Add a border around the terms section
    // const termsHeight = footerSections[0].length * 6 + 10;
    // doc.setLineWidth(0.5);
    // doc.setDrawColor(0, 0, 0);
    // doc.rect(margin, y - 5, pageWidth - 2 * margin, termsHeight);

    // footerSections[0].forEach((item, i) => {
    //   doc.setFontSize(item.size);
    //   doc.setFont('helvetica', item.bold ? 'bold' : 'normal');
    //   doc.text(item.text, margin + 5, y + 5 + i * 6);
    // });

    // Add page numbers
    const addPageNumbers = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');

        const pageNumberText = `Page ${i} of ${pageCount}`;
        const textWidth = doc.getTextWidth(pageNumberText);
        const xPosition = pageWidth - textWidth - 10;

        doc.text(pageNumberText, xPosition, pageHeight - 10);
      }
    };

    addPageNumbers(doc);

    // Generate filename and save
    const filename = generateUniqueFilename('Return_Invoice', 'pdf');
    // doc.save(filename);

    // Auto print and open
    doc.autoPrint();
    window.open(doc.output('bloburl'));

  } catch (error) {
    console.error('Error generating return PDF:', error);
  }
};

export default generateReturnPDF;